import { Zap } from "lucide-react";
import { LoginArea } from "@/components/auth/LoginArea";
import { SearchBar } from "@/components/SearchBar";
import { Link } from "react-router-dom";

export function Navbar() {
  return (
    <header className="sticky top-0 z-50 bg-background/80 backdrop-blur-xl border-b border-border/50">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between gap-4">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2.5 group flex-shrink-0">
            <div className="relative">
              <div className="absolute inset-0 bg-primary/20 rounded-2xl blur-lg group-hover:blur-xl transition-all opacity-0 group-hover:opacity-100" />
              <div className="relative bg-gradient-to-br from-primary to-primary/80 p-2.5 rounded-2xl shadow-md shadow-primary/20">
                <Zap className="h-5 w-5 text-primary-foreground fill-primary-foreground" />
              </div>
            </div>
            <span className="text-lg font-semibold tracking-tight hidden sm:inline">
              ZapMeACoffee
            </span>
          </Link>

          {/* Search */}
          <SearchBar className="flex-1 max-w-md" />

          {/* Login Area */}
          <LoginArea className="max-w-60 flex-shrink-0" />
        </div>
      </div>
    </header>
  );
}
